import React, {Component} from 'react';
import withBoardingRestrictionDrawer from '../withBoardingRestrictionDrawer';
import {FilterableTable} from './FilterableTable';
import withFlightDrawer from '../WithFlightDrawer';
import {compose} from 'recompose';
import {classNames} from 'common/util';
import './PassengerTable-style.less';
import {replaceColumn} from 'common/table/columns';

class PassengerTable extends Component {
    render() {
        let { columns, ...restProps } = this.props;
        const restriction = columns.find(col => col.key === 'restrictions');
        if (restriction){
            columns = replaceColumn(columns, 'restrictions', {
                render: (text, record, index) => (
                    restriction.render(text, record, index, () => this.props.boardingRestrictionsDrawer.open(record._id))
                )
            })
        }
        return (
            <React.Fragment>
                <FilterableTable
                    {...restProps}
                    className={classNames(restProps.className, 'mc-table-passengers')}
                    columns={columns}
                    components={{
                        body: {
                            // Uncomment below to enable row coloring
                            // row: this.ColorizedRow
                        }
                    }}
                />
            </React.Fragment>
        );
    }
}
 
export default compose(
    withFlightDrawer(),
    withBoardingRestrictionDrawer
)(PassengerTable)